export const UserStatus = [
   'CONFIRMED',
   'UNCONFIRMED',
   'NOT_IN_SSO',
   'COMPROMISED',
   'ARCHIVED',
   'RESET_REQUIRED',
   'FORCE_CHANGE_PASSWORD',
   'UNKNOWN',
] as const;
export type UserStatus = typeof UserStatus[number];

export interface AdminUserListItem {
   email: string;
   active: boolean;

   firstName: string;
   lastName: string;

   initials?: string;

   status: UserStatus;
   last_session?: Date;

   portals: { name: string, accounts: number }[];
}

export class AdminUserListItem implements AdminUserListItem {
   constructor( u: any ) {
      this.email = u?.email;
      this.active = u?.active;
      this.firstName = u?.firstName;
      this.lastName = u?.lastName;
      this.initials = `${this.firstName[0] ?? ''}${this?.lastName[0] ?? ''}`;

      this.status = u?.status;
      if ( u?.last_session ) { this.last_session = u?.last_session; }

      this.portals = u?.portals?.map( portal => ({
         name: ( portal.name === 'fourpl' ) ? '4pl' : portal.name,
         accounts: portal.accounts
      })) ?? [];
   }
}


export interface AdminListPortalUser {
   email: string;
   firstName: string;
   lastName: string;
}

export class AdminListPortalUser implements AdminListPortalUser {
   constructor( u?: any ) {
      this.email = u?.email;
      this.firstName = u?.firstName;
      this.lastName = u?.lastName;
   }
}


export interface AdminUserAccount {
   id: number;
   name?: string;
   primary: boolean;
   services: number[];
}

export class AdminUserAccount implements AdminUserAccount {
   constructor( a?: any ) {
      this.id = a?.id;
      this.name = a?.name;
      this.primary = a?.primary;
      this.services = a?.services;
   }
}

export interface AdminPortal {
   portalName: string;

   firstName: string;
   lastName: string;

   title?: string;
   phone?: string;


   lastSessionCreation?: Date;
   lastTermsUse?: Date;
   lastTermsConditions?: Date;

   accounts?: AdminUserAccount[];
}

export class AdminPortal implements AdminPortal {
   constructor( p?: any ) {
      this.portalName = p?.portalName ?? 'customer';

      this.firstName = p?.firstName;
      this.lastName = p?.lastName;

      if ( p?.title ) { this.title = p?.title; }
      if ( p?.phone ) { this.phone = p?.phone; }

      if ( p?.lastSessionCreation ) { this.lastSessionCreation = new Date( p?.lastSessionCreation ); }
      if ( p?.lastTermsUse ) { this.lastTermsUse = new Date( p?.lastTermsUse ); }
      if ( p?.lastTermsConditions ) { this.lastTermsConditions = new Date( p?.lastTermsConditions ); }

      this.accounts = [];
      if ( p?.accounts ) {
         p?.accounts.map( account => this.accounts.push( new AdminUserAccount( account )));
      }
   }
}

export interface AdminUser {
   email?: string;

   firstName: string;
   lastName: string;
   initials?: string;

   active: boolean;
   status: 'UNCONFIRMED' | 'CONFIRMED' | 'ARCHIVED' | 'COMPROMISED' | 'UNKNOWN' | 'RESET_REQUIRED' | 'FORCE_CHANGE_PASSWORD';
   lastAuthentication?: Date;

   preferredBrand?: string;


   portals: AdminPortal[];
}

export class AdminUser implements AdminUser {
   constructor( u?: any ) {
      this.email = u?.email;
      this.firstName = u?.firstName;
      this.lastName = u?.lastName;
      this.initials = `${this.firstName[0] ?? ''}${this?.lastName[0] ?? ''}`;

      this.active = u?.active ?? false;
      this.status = u?.status;
      if ( u?.lastAuthentication ) { this.lastAuthentication = new Date( u?.lastAuthentication ); }

      if ( u?.preferredBrand ) { this.preferredBrand = u?.preferredBrand; }

      this.portals = [];
      if ( u?.portals ) {
         u?.portals.map( portal => this.portals.push( new AdminPortal( portal )));
      }
   }
}
